import { Retailer } from '@emi/shared/models';
import { TimeSeriesPrice } from './time-series-price';

export class TimeSeriesDataRow {
  constructor(
    public retailer: Retailer,
    public timeSeriesPrices: TimeSeriesPrice[],
    public priceGrowthPercent?: number
  ) { }
}
